module.exports = __webpack_public_path__ + "static/media/eduprime-logo-white.f7ad1e24.png";